/**
 * 个人档案模块
 * 
 * 个人信息、时间线、附件管理
 */

import type { WorkbenchModule } from '../types'

export const profileModule: WorkbenchModule = {
  meta: {
    name: 'profile',
    title: '个人档案',
    description: '个人信息、经历时间线、附件管理',
    version: '0.1.0'
  },
  routes: [
    {
      path: '/profile',
      name: 'profile',
      component: () => import('./views/ProfileView.vue'),
      meta: { title: '个人档案' }
    },
    {
      path: '/profile/timeline',
      name: 'profile-timeline',
      component: () => import('./views/TimelineView.vue'),
      meta: { title: '时间线' }
    }
  ],
  menuItem: {
    id: 'profile',
    label: '个人档案',
    path: '/profile',
    icon: 'profile',
    order: 20
  }
}
